import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDE0ioHIRIzdFABaBGdkOkwu3zB_JbQWgs",
  authDomain: "sonikathechef-73394.firebaseapp.com",
  projectId: "sonikathechef-73394",
  storageBucket: "sonikathechef-73394.firebasestorage.app",
  messagingSenderId: "325320877151",
  appId: "1:325320877151:web:cb220dc3ad38a780a8a7ea",
};

const app = initializeApp(firebaseConfig);
const projDataBase = getFirestore(app);

export const auth = getAuth(app);

export { projDataBase };
